import { Button, Input, InputDate, TagGroup } from "@atomaro/ui-kit";
import { IDropdownMenuItem } from "@atomaro/ui-kit/components/DropdownMenu/types";
import InputNumberStepper from "@atomaro/ui-kit/components/InputNumberStepper/InputNumberStepper";
import Modal from "@atomaro/ui-kit/components/Modal/Modal";
import Select from "@atomaro/ui-kit/components/Select/Select";
import { ITagGroupItem } from "@atomaro/ui-kit/components/Tag/TagGroup/types";
import { useResize } from "app/lib/hooks/useResize";
import { useApiariesStore } from "entities/apiaries";
import { useDiaryStore } from "entities/diary";
import { ColItem } from "entities/diary/model/types";
import React, { FC, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import { CustomFieldsType, CustomFieldsTypeResponse, DiaryEntry, IDictionary, } from "shared/types/common";
import { AddLarge } from "shared/ui/icons";
import {
  DictionaryEditContent,
  DictionaryEditFooter,
  DictionaryEditHeaderRow,
  DictionaryEditPopup,
} from "widgets/dictionaryEditModal/ui/styles";
import { TableEditHeaderPopoverWrapper } from "../../diaryTable/styles";
import { DiaryRow } from "../../diaryTable/types";
import { NewEntrieDictionariesPopover, NewEntrieRow } from "../../styles";
import { TableEditHeaderDropDownItem, TitleValuesCustom, WrapperCustomFields, } from "./style";

type DiaryCustomFieldsProps = {
  editId?: string | number | undefined;
  tempFieldIdsRef?: React.RefObject<string[]>;
  customFields?: CustomFieldsTypeResponse[];
  customFieldsCol?: ColItem[];
  isSettings?: boolean;
  randomRows?: DiaryRow;
  handleChangeCustom?: (id: string) => void;
  setCustomFieldValue?: (fieldId: string, value: string) => void;
  customFieldValues?: any;
  setCustomFields?: (value: CustomFieldsType[]) => void;
  customDictionaryType?: Record<string, Partial<IDictionary>[]>;
  customDictionaryIds?: Record<string, string[]>;
  showDictionaries?: Record<string, IDictionary[]>;
  isDictionariesPopoverOpened?: Record<string, boolean>;
  onActiveDictionariesInputChange?: (
    fieldKey: string,
    value: string,
    name: string
  ) => void;
  onActiveDictionaryAdd?: (
    fieldKey: string,
    addedTag: ITagGroupItem,
    name: string
  ) => void;
  onActiveDictionaryRemove?: (
    fieldKey: string,
    removedTag: ITagGroupItem
  ) => void;
  onDictionaryClick?: (fieldKey: string, dictionary: IDictionary) => void;
  setIsDictionariesPopoverOpened?: (fieldKey: string, isOpen: boolean) => void;
};

export const DiaryCustomFields: FC<DiaryCustomFieldsProps> = ({
  editId,
  tempFieldIdsRef,
  customFields,
  isSettings,
  randomRows,
  handleChangeCustom,
  setCustomFieldValue,
  setCustomFields,
  customFieldsCol,
  onActiveDictionariesInputChange,
  onActiveDictionaryAdd,
  onActiveDictionaryRemove,
  setIsDictionariesPopoverOpened,
  showDictionaries,
  customFieldValues,
  isDictionariesPopoverOpened,
  onDictionaryClick,
  customDictionaryType
}) => {
  const [isNewFieldModalOpen, setIsNewFieldModalOpen] =
    useState<boolean>(false);
  const [newFieldName, setNewFieldName] = useState<string>("");
  const [newFieldType, setNewFieldType] = useState<string>("text");
  const [editingField, setEditingField] = useState<ColItem | null>();
  const [entry, setEntry] = useState<DiaryEntry>();
  //console.log("entry",entry)

  const isEditField = Boolean(editingField);
  const isEditEntry = Boolean(entry);

  const editEntry = useDiaryStore((s) => s.editEntry);
  const allEntries = useDiaryStore((s) => s.entries);
  const apiaryId = useApiariesStore((state) => state.currentApiaryId);
  const getDiaryEntriesFromServer = useDiaryStore(
    (s) => s.getDiaryEntriesFromServer
  );

  // const dictionariesRef = useRef<HTMLDivElement>(null);

  // useOutClick(dictionariesRef, () => {
  //   setIsDictionariesPopoverOpened?.('asdfasdf', true);
  // });


  const mergedFields =
    customFields?.map((field) => {
      const entryField = entry?.fields?.find((f) => f.id === field.id);
      
      return {
        ...field,
        value: isEditEntry
          ? entryField?.value
            ? entryField?.value
            : ""
          : entryField?.value,
        dictionaries: isEditEntry
          ? (entryField?.dictionaries ?? field.dictionaries)
          : field.dictionaries,
      };
    }) ?? [];

  //console.log("mergedFields", mergedFields);
  //console.log("customDictionaryType", customDictionaryType);

  const fieldTypeItems: IDropdownMenuItem[] = [
    { key: "text", value: "Текстовое поле" },
    { key: "number", value: "Цифровое поле" },
    { key: "date", value: "Дата" },
    { key: "dictionary", value: "Список" },
  ];

  const mapFieldTypeToApi = (
    type: string
  ): "TEXT" | "NUMBER" | "DATE" | "DICTIONARY" => {
    switch (type) {
      case "text":
        return "TEXT";
      case "number":
      case "NUMBER":
        return "NUMBER";
      case "date":
      case "DATE":
        return "DATE";
      case "dictionary":
      case "DICTIONARY":
        return "DICTIONARY";
      default:
        return "TEXT";
    }
  };

  const { isScreenLg } = useResize();
  const isMobile = !isScreenLg;

  const handleFieldTypeChange = (value: string | number) => {
    setNewFieldType(value as string);
  };

  const handleSaveNewField = async () => {
    const trimmedName = newFieldName.trim();
    if (!trimmedName) {
      toast.error("Введите название поля");
      return;
    }

    const normalizedName = trimmedName.toLowerCase();
    const editingFieldId = editingField ? editingField.key.replace("field-", "") : null;
    const hasDuplicate =
      (customFields ?? []).some(
        (field) =>
          field.name?.trim?.().toLowerCase() === normalizedName &&
          (!editingFieldId || field.id !== editingFieldId)
      );

    if (hasDuplicate) {
      toast.error("Поле с таким названием уже существует");
      return;
    }

    if (isSettings) {
      if (
        !randomRows ||
        !randomRows.id ||
        !trimmedName ||
        !randomRows.author ||
        !apiaryId
      ) {
        return;
      }

      const baseRequestBody = {
        hiveId: randomRows.hive.id,
        inspectedAt: randomRows.inspectedAt,
        frames: randomRows.frames,
        strength: randomRows.strength,
        brood: randomRows.brood,
        dictionaryIds:
          randomRows.dictionaries?.map((el) => el.id).filter((el) => el) || [],
        authorId: randomRows.author.id,
        attachmentIds:
          randomRows.attachments.map((el) => el.id).filter((el) => el) || [],
        note: randomRows.note,
        id: randomRows.id,
      };
      
      console.log('editingField => ', editingField);

      const fieldData = {
        id: editingField ? editingField.key.slice(6) : crypto.randomUUID(),
        name: trimmedName,
        type:
          editingField && editingField.type
            ? mapFieldTypeToApi(editingField.type)
            : mapFieldTypeToApi(newFieldType),
        ...(newFieldType === "dictionary"
          ? {
              dictionaryType: trimmedName,
              dictionaryIds: [],
            }
          : {
            value:
              newFieldType === "number"
                ? 0
                : newFieldType === "date"
                  ? new Date().toISOString()
                  : "",
            }),
      };

      const responseBody = {
        ...baseRequestBody,
        fields: [fieldData],
      };

      try {
        const response = await editEntry(responseBody);
        getDiaryEntriesFromServer({
          apiaryId,
          page: { index: 0, size: 10 },
        });

        if (response?.data) {
          localStorage.removeItem("activeCols");
          toast.success(editingField ? "Поле успешно обновлено" : "Поле успешно создано");
          setIsNewFieldModalOpen(false);
          setEditingField(null);
          setNewFieldName("");
          setNewFieldType("text");
        }
      } catch (error: any) {
        console.error("Ошибка при создании поля:", error);
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          "Не удалось создать поле";
        toast.error(errorMessage);
      }
    } else {
      const newField =
        newFieldType === "dictionary"
          ? {
              id: crypto.randomUUID(),
              name: trimmedName,
              type: mapFieldTypeToApi(newFieldType),
              dictionaryType: trimmedName,
              dictionaryIds: [] as string[],
            }
          : {
              id: crypto.randomUUID(),
              name: trimmedName,
              type: mapFieldTypeToApi(newFieldType),
              value:
                newFieldType === "number"
                  ? 0
                  : newFieldType === "date"
                    ? new Date().toISOString()
                    : "",
            };

      if (!setCustomFields) return;
      setCustomFields([...(customFields ?? []), newField]);
      tempFieldIdsRef?.current.push(newField.id);
      setIsNewFieldModalOpen(false);
      setNewFieldName("");
      setNewFieldType("text");
    }
  };
  useEffect(() => {
    const currentEditField = allEntries.find((en) => en.id === editId);
    setEntry(currentEditField);
  }, [allEntries]);

  useEffect(() => {
    if (editingField && editingField.type) {
      setNewFieldName(editingField.value);
      setNewFieldType(mapFieldTypeToApi(editingField.type));
      setNewFieldName(editingField.value ?? "");
    } else {
      setNewFieldName("");
      setNewFieldType("text");
      setNewFieldName("");
    }
  }, [editingField]);

  

  return (
    <WrapperCustomFields> 
      {customFieldsCol?.length !== 0 && (
        <TitleValuesCustom isSettings={isSettings}>
          Пользовательские поля
        </TitleValuesCustom>
      )}
      <TableEditHeaderPopoverWrapper
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {isSettings &&
          customFieldsCol?.map((field) => (
            <TableEditHeaderDropDownItem
              isSettings={isSettings}
              $isActive={field.isSelected}
              onClick={() => handleChangeCustom?.(field.key)}
            >
              <NewEntrieRow>
                {isSettings && field.isSelected && (
                  <i>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.0294 5.03033L7.02941 12.0303C6.73652 12.3232 6.26164 12.3232 5.96875 12.0303L1.96875 8.03033L3.02941 6.96967L6.49908 10.4393L12.9688 3.96967L14.0294 5.03033Z"
                        fill="currentColor"
                      />
                    </svg>
                  </i>
                )}

                <span>{field.value}</span>
              </NewEntrieRow>
              {isSettings && (
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsNewFieldModalOpen(true);
                    setEditingField(field);
                  }}
                  variant="ghost"
                  colorScheme={field.isSelected ? "accent" : "neutral"}
                  iconPrefix={
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.1605 3.91328L11.5239 3.21863C11.2778 2.95009 10.8617 2.9288 10.5894 3.17083L9.5476 4.09708L11.0797 5.78845L12.1143 4.85986C12.3904 4.61212 12.4111 4.18672 12.1605 3.91328ZM3.66675 9.32542L8.80021 4.76154L10.3355 6.4564L5.27124 11.0016H3.66675V9.32542ZM12.8977 3.23763L12.2611 2.54297C11.6458 1.87162 10.6056 1.81841 9.92502 2.42347L2.89046 8.67751C2.74816 8.80402 2.66675 8.98534 2.66675 9.17575V11.3349C2.66675 11.7031 2.96522 12.0016 3.33341 12.0016H5.39889C5.56327 12.0016 5.72185 11.9409 5.84419 11.8311L12.7823 5.60408C13.4724 4.98473 13.5243 3.92123 12.8977 3.23763ZM13.3334 12.9999H2.66675V13.9999H13.3334V12.9999Z"
                        fill={
                          field.isSelected
                            ? COLORS.ACCENT.DEFAULT
                            : COLORS.FG.DISABLED
                        }
                      />
                    </svg>
                  }
                />
              )}
            </TableEditHeaderDropDownItem>
          ))}
        {mergedFields?.map((field) => {
          return (
          <>
            {field.type === "TEXT" && (
              <NewEntrieRow>
                <span>{field.name}</span>
                <div style={{ width: toRem(220) }}>
                  <Input
                    placeholder="Введите текст"
                    name={`custom-field-${field.id}`}
                    value={customFieldValues?.[field.id] ?? field.value ?? ""}
                    size="m"
                    onChange={(e) =>
                      setCustomFieldValue?.(field.id, e.target.value)
                    }
                  />
                </div>
              </NewEntrieRow>
            )}
            {field.type === "NUMBER" && (
              <NewEntrieRow>
                <span>{field.name}</span>
                <InputNumberStepper
                  name={`custom-field-${field.id}`}
                  value={
                    customFieldValues?.[field.id] !== undefined
                      ? Number(customFieldValues[field.id])
                      : Number(field.value ?? 0)
                  }
                  min={0}
                  size="m"
                  onChange={(value) => {
                    setCustomFieldValue?.(field.id, String(value));
                  }}
                />
              </NewEntrieRow>
            )}
            {field.type === "DATE" && (
              <NewEntrieRow>
                <span>{field.name}</span>

                <InputDate
                  maxDate={new Date()}
                  size="m"
                  {...(() => {
                    const value =
                      customFieldValues?.[field.id]
                        ? new Date(customFieldValues[field.id])
                        : field.value
                          ? new Date(field.value as string)
                          : new Date();
                    return value ? { activeDate: value } : {};
                  })()}
                  maxYear={new Date().getFullYear()}
                  onChange={(date) => {     
                      setCustomFieldValue?.(field.id, date?.toISOString() ?? '');
                  }}
                />
              </NewEntrieRow>
            )}
            {field.type === "DICTIONARY" && (
              <NewEntrieRow >
                <span>{field.name}</span>
                <TagGroup
                  editable
                  closable
                  items={((customDictionaryType?.[field.id] ?? field.dictionaries) || []).map((d) => ({
                    value: d.name,
                    key: d.id || "",
                  }))}
                  onChangeInput={(value) =>
                    onActiveDictionariesInputChange?.(
                      field.id,
                      value,
                      field.name
                    )
                  }
                  onAdd={(tag) =>
                    onActiveDictionaryAdd?.(field.id, tag, field.name)
                  }
                  onRemove={(tag) => onActiveDictionaryRemove?.(field.id, tag)}
                  inputProps={{
                    onFocus: () =>{ onActiveDictionariesInputChange?.(field.id,' ',field.name)
                      setIsDictionariesPopoverOpened?.(field.id, true)},
                    onClick: () =>{ onActiveDictionariesInputChange?.(field.id,' ',field.name)
                      setIsDictionariesPopoverOpened?.(field.id, true)},
                  }}
                />

                {Boolean(showDictionaries?.[field.id]?.length) &&
                  isDictionariesPopoverOpened?.[field.id] && (
                    <NewEntrieDictionariesPopover className="_has-overflow">
                      {showDictionaries?.[field.id]?.map((showDictionary) => (
                        <span
                          key={showDictionary.id}
                          onClick={() => {
                              onDictionaryClick?.(field.id, showDictionary);
                              setIsDictionariesPopoverOpened?.(field.id, false);
                            }
                          }
                        >
                          {showDictionary.name}
                        </span>
                      ))}
                    </NewEntrieDictionariesPopover>
                  )}
              </NewEntrieRow>
            )}
          </>
        )})}
      </TableEditHeaderPopoverWrapper>
      <Button
        size="m"
        colorScheme="neutral"
        variant="outline"
        label="Новое поле"
        disabled={mergedFields?.length >= 10}
        style={{ width: "auto", marginLeft: "12px", marginRight: "12px" }}
        iconPrefix={<AddLarge fill={COLORS.FG.DEFAULT} />}
        type="button"
        onClick={() => {
          setIsNewFieldModalOpen(true);
          // drawerProps.onClose();
        }}
      />
      <Modal
        isOpen={isNewFieldModalOpen}
        centered
        useInPortal
        style={{ padding: 0, overflow: "visible" }}
        maxWidth={isMobile ? "100vw" : "450px"}
        maxHeight={isMobile ? "100vh" : "auto"}
        onClickOverlay={() => {
          setEditingField(null);
          setIsNewFieldModalOpen(false);
          setNewFieldName("");
          setNewFieldType("text");
        }}
      >
        <DictionaryEditPopup>
          <DictionaryEditHeaderRow>
            <h3>{isEditField ? " Редактирование поля" : "Новое поле"}</h3>
            <svg
              onClick={() => {
                setEditingField(null);
                setIsNewFieldModalOpen(false);
                setNewFieldName("");
                setNewFieldType("text");
              }}
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              width="24.000000"
              height="24.000000"
              fill="none"
            >
              <rect
                id="24 / Navigation / Close Large"
                width="24.000000"
                height="24.000000"
                x="0.000000"
                y="0.000000"
              />
              <path
                id="Union"
                d="M10.9401 12.0006L4.99902 17.9417L6.05968 19.0023L12.0008 13.0612L17.9418 19.0023L19.0025 17.9417L13.0614 12.0006L19.0025 6.0595L17.9418 4.99884L12.0008 10.9399L6.0597 4.99884L4.99904 6.0595L10.9401 12.0006Z"
                fill="rgb(16,24,40)"
                fillRule="evenodd"
              />
            </svg>
          </DictionaryEditHeaderRow>
          <DictionaryEditContent>
            <Input
              placeholder="Название поля"
              name="field-name"
              value={newFieldName}
              size="l"
              label="Название"
              onChange={(e) => setNewFieldName(e.target.value)}
            />
            {!isEditField && (
              <Select
                name="field-type"
                value={newFieldType}
                defaultValue="text"
                placement="bottom"
                items={fieldTypeItems}
                label="Тип поля"
                onChange={handleFieldTypeChange}
                useInPortal={false}
                autocomplete={{ enabled: false }}
                dropdownMenuStyle={{
                  maxHeight: toRem(300),
                  overflowY: "auto",
                  zIndex: 999,
                }}
              />
            )}
          </DictionaryEditContent>
          <DictionaryEditFooter isMobile={!!isMobile}>
            <Button
              size={isMobile ? "l" : "m"}
              colorScheme="neutral"
              variant="ghost"
              label="Отменить"
              onClick={() => {
                setEditingField(null);
                setIsNewFieldModalOpen(false);
                setNewFieldName("");
                setNewFieldType("text");
              }}
              style={{
                width: "100%",
              }}
            />
            <Button
              size={isMobile ? "l" : "m"}
              colorScheme="accent"
              label="Сохранить"
              onClick={handleSaveNewField}
              style={{
                width: "100%",
              }}
              disabled={!newFieldName.trim()}
            />
          </DictionaryEditFooter>
        </DictionaryEditPopup>
      </Modal>
    </WrapperCustomFields>
  );
};
